import Vue from "vue";

Vue.filter("NumFormat", function (value) {  //2,450.00
  // if (!value) return "0.00";
  if (!value) return "-";
  var intPart = value.toString().split(".")[0];

  var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");

  var floatPart = ".00";
  var value2Array = value.toString().split(".");
  if (value2Array.length === 2) {
    floatPart = value2Array[1].toString();

    if (floatPart.length === 1) {
      return intPartFormat + "." + floatPart + "0";
    } else {
      return intPartFormat + "." + floatPart;
    }
  } else {
    return intPartFormat + floatPart;
  }
});

Vue.filter("FormatNum", function (num) {    //2.45k
  if ( /^[0-9]+(,[0-9]+)*(\.[0-9]+)?$/.test(num) ) { //判断字符串是纯数字,逗号和小数点 
        num = !isNaN(parseFloat(String(num).replace(/,/g, '')))?parseFloat(String(num).replace(/,/g, '')):num;
  }
  var res=num;
  if( !isNaN(num) && isFinite(num) ){
      if( num>=1000&& num<1000000){
        res=(num / 1000).toFixed(2)+" K";
      }
      if( num>=1000000&& num<1000000000){
        res=(num / 1000000).toFixed(2)+" M";
      }
      if( num>=1000000000 ){
        res = parseFloat((num / 1000000000 ).toFixed(2)).toLocaleString()+ " B";
      }
  }
       
  return res; 
});

Vue.filter("FormatPerWith1", function (num) {    //2.45%   <1%
  var res=num;
  if( !isNaN(num) && isFinite(num) ){ 
     res= num.toFixed(2)<1?"<1%": (num.toFixed(2)+ "%");
    } 
  return res; 
});

//格式化数字，逗号分割 三位一,
Vue.filter("FilterNum", function (num) {
  var flag = String(num).includes("%");
  if (num == "20+") {
    return num;
  } else {
    const newNum = parseInt(num);
    if (newNum) {
      if ((num + "").trim() == "") {
        return "";
      }
      if (String(num).indexOf(",") == -1) {
        num = parseFloat(num);
        num = num.toFixed(2);
        num = parseFloat(num);
        num = num.toLocaleString();
      } else {
        num = num.replace(/,/gi, "");
        num = parseFloat(num).toLocaleString();
      }
     num = num + (flag ? "%" : "")
    }
    return num  ;
  }
});